import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import { URL } from '~/config/uri';

export default class CardRecord extends RecordBase {

  static defaultAttributes = {
    is_active:                  true,
    name:                       '',
    description:                '',
    lang:                       'pt-BR',
    bg_color:                   '#ffffff',
    text_color:                 '#000000',
    title_color:                '$000000',
    type:                       'img_left',
    url:                        '',
    deleted_at:                 '',
    created_at:                 '',
    updated_at:                 '',
    image:                      null,
    image_base64:               null,
    archive_id:                 null,
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    if(!this._attributeNames){
      this._attributeNames = {
        is_active:              t('cards.attributes.is_active'),
        name:                   t('cards.attributes.name'),
        description:            t('cards.attributes.description'),
        lang:                   t('cards.attributes.lang'),
        bg_color:               t('cards.attributes.bg_color'),
        text_color:             t('cards.attributes.text_color'),
        title_color:            t('cards.attributes.title_color'),
        type:                   t('cards.attributes.type'),
        url:                    t('cards.attributes.url'),
        deleted_at:             t('cards.attributes.deleted_at'),
        created_at:             t('cards.attributes.created_at'),
        updated_at:             t('cards.attributes.updated_at'),
        image:                  t('cards.attributes.image'),
        image_base64:           t('cards.attributes.image_base64'),
        archive_id:             t('cards.attributes.archive_id'),
      };
    }

    return this._attributeNames;
  }

  getImageUrl(){
    return `${URL}${this.get('image').file_path}`;
  }

  toParams(attrs={}){
    const {
      is_active,
      name,
      description,
      lang,
      bg_color,
      text_color,
      title_color,
      type,
      url,
      image,
      archive_id,
    } = this.toObject();

    return {
      data:{
        attributes:{
          is_active,
          name,
          description,
          lang,
          bg_color,
          text_color,
          title_color,
          type,
          url,
          image,
          archive_id,
          ...attrs,
        }
      }
    };
  }
}
